// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Spinner } from '@lmc/ui-kit'
import { debounce } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { getJSON } from '../../../../common/services/api'
import { formatAddress } from '../../../../common/utils'
import { FormInput } from '../../../../LEGACY/elemental'

const WAIT_TIME = 500
const BAD_POSTCODE_ERROR =
  'No addresses found. Please enter a full UK postcode.'
const SERVER_ERROR =
  'Oops! Something went wrong. Please refresh the page and try again.'
const GET_ADDRESS_URL = `/api/services/get-address`

export default class AddressSearch extends React.Component {
  state = {
    loading: false,
    results: null
  }

  fetchResults = (url) => {
    getJSON({ url })
      .then((res) => {
        this.handleResults({ results: res.result })
      })
      .catch((e) => {
        let error
        if (e.message === 'Bad Request') {
          error = BAD_POSTCODE_ERROR
        } else {
          error = SERVER_ERROR
        }
        this.handleResults({ error })
      })
  }

  // maps getAddress() API results to existing LmC field keys
  formatResults = (results) => ({
    ...results,
    addresses: results.addresses.map((address) => {
      const hasName = !!address.sub_building_name.length
      const area = address.locality || address.district

      let name
      let street1
      let street2

      if (hasName) {
        name = address.sub_building_name
        street1 = address.line_2
        street2 = address.line_3.length ? address.line_3 : area
      } else {
        name = null
        street1 = address.line_1
        street2 = address.line_2.length ? address.line_2 : area
      }

      return {
        name,
        street1,
        street2,
        suburb: address.town_or_city,
        state: address.county
      }
    })
  })

  handleChange = (e) => {
    this.props.onChange(e)
    if (!e.target.value) {
      this.setState({ results: null })
      return
    }
    this.handleFindAddress()
  }

  handleFindAddress = debounce(() => {
    const { isShowingFields, value } = this.props
    if (isShowingFields || !value || !value.length) {
      return
    }

    this.setState({ loading: true })
    const postcode = this.props.value.replace(/\s/g, '')
    this.fetchResults(`${GET_ADDRESS_URL}/${postcode}`)
  }, WAIT_TIME)

  handleResults = ({ results, error }) => {
    this.setState({
      results: error || this.formatResults(results),
      loading: false
    })
  }

  handleSelect = (address, postcode) => {
    this.props.onSelect({
      ...address,
      postcode
    })
    this.setState({
      results: null
    })
  }

  onShowFields = () => {
    this.setState({ results: null })
    this.props.onShowFields()
  }

  renderResults = (results) => {
    if (!results.addresses)
      return <div style={styles.resultsRow}>{results}</div>
    return results.addresses.map((address, i) => (
      <div
        className="lmc-select-address-option"
        key={i}
        onClick={() => this.handleSelect(address, results.postcode)}
        style={styles.resultsRow}
      >
        {formatAddress(address)}
      </div>
    ))
  }

  renderResultsBox = (loading, results) => (
    <div style={styles.resultsWrapper}>
      {loading && (
        <div style={styles.spinner}>
          <Spinner />
        </div>
      )}
      {results && this.renderResults(results)}
    </div>
  )

  render() {
    const { value, isShowingFields } = this.props
    const { loading, results } = this.state
    return (
      <div>
        <FormInput
          onChange={this.handleChange}
          placeholder="Start typing here"
          value={value}
        />
        {(loading || results) && this.renderResultsBox(loading, results)}
        {!isShowingFields && (
          <a onClick={this.onShowFields} style={styles.link}>
            Type address manually{' '}
            <span className="octicon octicon-chevron-right" />
          </a>
        )}
      </div>
    )
  }
}

const styles = {
  button: {
    background: colors.grey,
    color: colors.darkgrey,
    marginTop: 10,
    textShadow: 'none'
  },
  link: {
    display: 'inline-block',
    marginTop: 5,
    float: 'right',
    textDecoration: 'none'
  },
  resultsRow: {
    padding: '4px 12px'
  },
  resultsWrapper: {
    background: 'white',
    boxShadow: '0 0 0 1px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 8,
    maxHeight: 200,
    padding: '4px 0px',
    overflow: 'auto'
  },
  spinner: {
    textAlign: 'center'
  }
}

AddressSearch.propTypes = {
  isShowingFields: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onShowFields: PropTypes.func.isRequired,
  value: PropTypes.string
}

AddressSearch.defaultProps = {
  isShowingFields: false
}
